import React, { FC, memo } from 'react';
import Button from '../../ui/Button';
import IconSvg from '../../ui/IconSvg';
import IconSvgPayment from '../IconSvgPayment';
import { useTranslation } from 'react-i18next';
import useLastCallback from '../../../hooks/useLastCallback';

import classNames from 'classnames';
import { AiPrompt, GlobalState } from '../../../global/types';
import { withGlobal } from '../../../global';

type OwnProps = {
  onByPack: (pack: AiPrompt) => void;
  prompt: AiPrompt;
};

type StateProps = Pick<GlobalState, 'aiPurchases'>;

const PaymentAiItem: FC<OwnProps & StateProps> = ({
  onByPack,
  prompt,
  aiPurchases,
}) => {
  const { t } = useTranslation();

  const { name } = prompt;

  const handleByPack = useLastCallback(() => {
    onByPack(prompt);
  });

  return (
    <>
      <div className={classNames('payment-item', `ai-${name}`)}>
        <IconSvgPayment name={`${name}-round`} />
        <div className='bottom-row'>
          <div className='start-col'>
            <div className='title'>
              {t(`PaymentAi.${name}.Title`)}
              {/* {aiPurchases && aiPurchases[`${name}_sub_active`] && (
                <span>Active</span>
              )} */}
            </div>
            <p className='description'>{t(`PaymentAi.${name}.BuyPack`)}</p>
          </div>
          <Button
            round
            onClick={handleByPack}
            ariaLabel={String(t('PaymentAi.BuyPack'))}
          >
            <i className='icon-svg'>
              <IconSvg name='arrow-right' />
            </i>
          </Button>
        </div>
      </div>
    </>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const { aiPurchases } = global;
    return { aiPurchases };
  })(PaymentAiItem)
);
